import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppInitializerService } from '@app/app-initializer.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';

@Injectable({
	providedIn: 'root'
})
export class ApiService {

	headers: any = {
		'Content-Type': 'application/json'
	};

	constructor(
		private http: HttpClient,
		private gfService: GlobalFunctionService,
		private appInit: AppInitializerService
	) { }

	roleMappingList(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `role`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	competencyList(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `skills/competency`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	getCompetencyForRole(params: any = {}, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `skills/${id}/competency`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	getSkillForCompetency(params: any = {}, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `skills/${id}`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	getSkillForRoleCompetency(params: any = {}, roleID: number, competencyID: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `skills/${roleID}/${competencyID}/skills`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	addRoleMapping(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `role`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}

	addCompetency(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `skills/competency`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}

	addCompetencyForRole(params: any = {}, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `skills/${id}/competency`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}

	addSkillForCompetency(params: any = {}, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `skills/${id}/skills`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}

	updateRole(params: any, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `role/${id}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	updateCompetency(params: any, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `skills/competency/${id}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	updateSkill(params: any, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `skills/skill/${id}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	updateSkillLevel(params: any, roleID: number, competencyID: number, skillID: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `skills/${roleID}/${competencyID}/${skillID}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	deleteRole(id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `role/${id}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.delete(api, options);
	}

	deleteCompetency(id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `skills/competency/${id}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.delete(api, options);
	}

	deleteRoleCompetency(roleID: number, competencyID: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `skills/${roleID}/competency/${competencyID}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.delete(api, options);
	}

	deleteSKill(params: any = {}, competencyID: number, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `skills/${competencyID}/skill/${id}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers),
			body: params
		};
		return this.http.delete(api, options);
	}
}
